import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import BodyCopy from "../BodyCopy/BodyCopy";

import Card from "../Card/Card";
import Button from "../Button/Button";

import "./dashboard-card.scss";

const DashboardCard = ({
  heading,
  children,
  button,
  illustration,
  backgroundColor,
  className,
  ...props
}) => {
  const classes = classNames("dashboard-card", className);

  const componentProps = {
    backgroundColor,
    className: classes,
    ...props,
  };

  return (
    <Card {...componentProps}>
      {illustration && (
        <div className="dashboard-card__illustration-container u-margin-bottom-1">
          <img src={illustration} alt="" className="dashboard-card__illustration" />
        </div>
      )}
      <div className="dashboard-card__content-container">
        <h2 className="dashboard-card__heading h500 u-font-heading">{heading}</h2>
        {children && <BodyCopy className="dashboard-card__content">{children}</BodyCopy>}
        {button && <div className="dashboard-card__button-container">{button}</div>}
      </div>
    </Card>
  );
};

DashboardCard.propTypes = {
  backgroundColor: PropTypes.oneOf(["white", "red", "black", "grey"]),
  heading: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  button: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Button)]),
  illustration: PropTypes.string,
  className: PropTypes.string,
};
export default DashboardCard;
